import { Component } from "react";
import PropTypes from "prop-types";
import { BackendButton } from "../../../auth/BackendButton.js";

class MandatorsComponent extends Component {
  render() {
    let mainInfoStyle = { padding: "8px 4px 4px 16px" };
    let mandators = this.props.currentUser.OrgIdentityData.Mandators;
    let mandatorIds = Object.keys(mandators);

    return (
      <div>
        <h4>Mandators ({mandatorIds.length})</h4>
        <h5 style={{ color: "red" }}>
          To remove mandator click on the mandator Id and then click trash icon
          on person page (backend admin).{" "}
        </h5>
        <div style={mainInfoStyle}>
          {mandatorIds.map((Id) => {
            return (
              <div
                key={Id}
                style={{ position: "relative", marginBottom: "20px" }}
              >
                <div style={{ marginLeft: "60px" }}>
                  mandator person id:
                  <BackendButton label={Id} url={`/savelend/persons/${Id}`} />
                  <br />
                  mandator ssn : {mandators[Id]}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    addMandatorToOrganization: PropTypes.func,
    removeMandatorToOrganization: PropTypes.func,
  };
}

export const Mandators = MandatorsComponent;
